import React from 'react';
import ReactDOM from 'react-dom'
import Header from '../../component/header'
import List from '../../component/list'
import FloatMenu from '../../component/floatMenu'
import GTip from '../../component/gTip'
import { AppContext, defaultState } from '../../config/context'
import '../../common/util/channel'
import '../../common/util/polyfill'
import initReportEnv from '../../common/util/report'

initReportEnv('列表页')

class App extends React.Component {
    constructor() {
        super()
        this.updateUserInfo = user => {
            this.setState(state => ({
                user: {
                    ...state.user,
                    ...user
                }
            }))
        }
        this.state = {
            ...defaultState,
            updateUserInfo: this.updateUserInfo
        }
    }

    render() {
        return <AppContext.Provider value={this.state}>
            <Header></Header>
            <List></List>
            <GTip></GTip>
            <FloatMenu></FloatMenu>
        </AppContext.Provider>
    }
}

ReactDOM.render(<App />, document.getElementById('dokodemodoa'))